// components/filter/time-filter/time-filter.component.jsx
import React from "react";
import { useDispatch } from "react-redux";

import { toggleTime } from "../../../redux/filter/filter.actions";
import HoverDropdown from "../../dropdown/dropdown";

import "./time-filter.styles.scss";

const TimeFilter = ({ time }) => {
  const dispatch = useDispatch();

  const options = [
    { value: "all", label: "all times" },
    { value: -2, label: "past due" },
    { value: 0, label: "today" },
    { value: 1, label: "tomorrow" },
    { value: 7, label: "this week" },
    { value: 30, label: "this month" },
  ];

  const selectedValue = time == null ? "all" : time;

  const handleChange = (value) => {
    dispatch(toggleTime(value === "all" ? null : value));
  };

  return (
    <div className="timeFilter">
      <HoverDropdown
        options={options}
        value={selectedValue}
        onChange={handleChange}
        hasCaret
        usePortal={false}
        hoverPadding={0}
        className={`timeFilter-dropdown ${
          selectedValue === "all" ? "is-default" : "is-filtered"
        }`}
      />
    </div>
  );
};

export default TimeFilter;